import React from "react";
import PropTypes from "prop-types";
import "./Stepper.scss";
import parse from "html-react-parser";

const Stepper = ({ contentList }) => {
  return (
    <>
      {contentList?.map((listItem, index) => {
        return (
          <div key={listItem} className={"step-container"}>
            <div className="stepCountContainer">
              <div className="stepIndicator">
                {index + 1}{" "}
              </div>
            </div>
            <div className="stepContents">
              <p>{parse(listItem)}</p>
            </div>
            {index + 1 !== contentList?.length && (
              <div className="step-line"></div>
            )}
          </div>
        );
      })}
    </>
  );
};

Stepper.propTypes = {
  contentList: PropTypes.array,
};
export default Stepper;
